<template>
  <div id="DataVersionInfo" v-loading="loading">
    <el-collapse v-model="activeNames" :accordion="accordion" class="VersionManage_list">
      <el-collapse-item v-for="(item, index) in dataVersionList" :key="index" class="VersionManage_item" :name="item.fileRevisionId">
        <template slot="title">
          <div class="VersionManage_item_title">{{ item.version }}</div>
          <el-tooltip effect="dark" content="在应用端可直接使用该版本资源" placement="top">
            <div v-show="item.status" class="VersionManage_item_status">当前启用</div>
          </el-tooltip>
          <el-tooltip effect="dark" content="正在转换中，请稍候" placement="bottom-start">
            <img v-show="item.bimfaceTranslateStatus === 'PROCESSING'" src="../../../assets/img/icon_zhuanhuanzhong.png" alt="" class="mg-lt-sm" />
          </el-tooltip>
          <el-tooltip effect="dark" content="查看轻量化模型" placement="bottom-start">
            <img v-show="item.bimfaceTranslateStatus === 'SUCCESS'" src="../../../assets/img/icon_zhuanhuanchenggong.png" alt="" class="mg-lt-sm" @click.stop="$emit('view-3d', item)" />
          </el-tooltip>
          <div class="VersionManage_item_oper">
            <el-button v-show="item.status && btnObj.isShowLink" type="text" :disabled="hasPermission(permissionType, 'FILE_LINK')" @click.stop="$emit('onLink')">链接</el-button>
            <el-button v-show="item.status && btnObj.isShowImport" type="text" :disabled="hasPermission(permissionType, 'FILE_IMPORT')" @click.stop="$emit('onImport')">导入</el-button>
            <el-button :loading="item.downloadLoading" type="text" :disabled="hasPermission(permissionType, 'FILE_DOWNLOAD')" @click.stop="download(item)">下载</el-button>
            <el-button v-show="!item.status" type="text" :disabled="hasPermission(permissionType, 'FILE_DATA_VERSION_ENABLE')" @click.stop="open(item)">启用</el-button>
            <el-button v-show="!item.status" type="text" :disabled="hasPermission(permissionType, 'FILE_DATA_VERSION_DELETE')" @click.stop="del(item)">删除</el-button>
          </div>
        </template>
        <div v-for="(item2, index2) in item.records || []" :key="index2" class="VersionManage_item_record">
          <span class="operationDate">{{ $fmtTime(item2.operationDate) }}</span>
          <span class="userName ellipsis-text" :title="item2.userName">{{ item2.userName }}</span>
          <span class="operation ellipsis-text" :title="item2.operation">{{ item2.operation }}</span>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import permissionMixin from '@/mixins/permissionMixin.js'
import { downloadErrorCodeMap, startNewVersionErrorCodeMap, deleteVersionRecordErrorCodeMap } from '../errorCodeMap'
export default {
  name: 'DataVersionInfo',
  mixins: [permissionMixin],
  props: {
    accordion: {
      type: Boolean,
      default: false
    },
    spaceId: {
      type: [String, Number],
      default: ''
    },
    fileId: {
      type: [String, Number],
      default: ''
    },
    dataVersionList: {
      type: Array,
      default: () => []
    },
    permissionType: {
      type: String
    },
    btnObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      activeNames: []
    }
  },
  computed: {
    ...mapGetters({
      clientType: 'platform',
    }),
  },
  watch: {
    dataVersionList: {
      handler(nval, oval) {
        if (nval && nval.length > 0) {
          const item = nval.find((f) => f.status)
          this.activeNames = item ? item.fileRevisionId : nval[0].fileRevisionId
        }
      },
      setImmediate: true,
    }
  },
  created() {
    if (this.dataVersionList && this.dataVersionList.length > 0) {
      const item = this.dataVersionList.find((f) => f.status)
      this.activeNames = item ? item.fileRevisionId : this.dataVersionList[0].fileRevisionId
    }
  },
  methods: {
    // 启用
    open(item) {
      this.$confirm('确定启用该版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.loading) {
          return false
        }
        if (item.status) {
          return false
        }
        this.$api.file.startNewVersion(this.spaceId, this.fileId, item.fileRevisionId).then((res) => {
          this.dataVersionList.forEach((element) => {
            element.status = false
          })
          item.status = true
          this.activeNames = item.fileRevisionId
          this.$emit('version-changed')
        }).catch((err) => {
          err?.code && this.$matchError(err.code, startNewVersionErrorCodeMap, '启用数据版本失败')
        }).finally((e) => {
          this.loading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消启用该版本'
        })
      })
    },
    // 下载
    download(item) {
      if (item.downloadLoading) {
        return false
      }
      this.$set(item, 'downloadLoading', true)
      this.$api.file.versionRecordsDownload(this.spaceId, this.fileId, item.fileRevisionId).then((res) => {
        if (res) {
          if (this.clientType === 'web') {
            this.$downloadFile(res)
          } else {
            this.$desktopClient.NavigateToBrowser(res)
          }
          this.$emit('download')
        }
      }).catch((err) => {
        this.$matchError(err.code, downloadErrorCodeMap, '获取下载地址失败')
      }).finally((e) => {
        item.downloadLoading = false
      })
    },
    // 删除
    del(item) {
      this.$confirm('确定删除该版本?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.loading) {
          return false
        }
        if (item.status) {
          return false
        }
        this.$api.file.deleteVersionRecord(this.spaceId, this.fileId, item.fileRevisionId).then(async(res) => {
          if (res) {
            this.$emit('version-changed')
          }
        }).catch((err) => {
          this.$matchError(err.code, deleteVersionRecordErrorCodeMap, '删除数据版本失败')
        }).finally((e) => {
          this.loading = false
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.VersionManage_item:first-child {
  /deep/.el-collapse-item__header {
    border-top: 1px solid @border-color;
    border-bottom: 1px solid @border-color;
    background: @bg-grey-light-2;
  }
}
.VersionManage_item {
  /deep/.el-collapse-item__header {
    border-bottom: 1px solid @border-color;
    background: @bg-grey-light-2;
    height: 32px;
    line-height: 32px;
    padding-left: 40px;
    position: relative;
    font-size: 14px;
    .VersionManage_item_title {
      flex-basis: 20%;
    }
    .VersionManage_item_status {
      background: #E6F7FF;
      color: @theme-color;
      border: 1px solid #91D5FF;
      border-radius: 2px;
      height: 22px;
      line-height: 22px;
      width: 74px;
      text-align: center;
      font-size: 12px;
      margin-left: 5px;
    }
    .VersionManage_item_oper {
      display: flex;
      justify-content: right;
      width: 90%;
      padding-right: 4px;
    }
  }
  /deep/.el-collapse-item__arrow {
    position: absolute;
    left: 15px;
  }

  /deep/.el-collapse-item__content {
    padding: 4px 0;
    font-size: 12px;
    .VersionManage_item_record {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      padding: 4px 16px;
      .operationDate {
        flex: 0 0 105px;
        padding-left: 24px;
      }
      .userName {
        flex: 0 0 140px;
        width: 140px;
        margin: 0 20px;
      }
      .operation {
        flex: 1;
        text-align: right
      }
    }
  }
}
.VersionManage_item.is-active + .VersionManage_item {
  /deep/.el-collapse-item__header {
    border-top: 1px solid @border-color;
    border-bottom: 1px solid @border-color;
    background: @bg-grey-light-2;
  }
}

</style>

